(function () {
  // ── Metal/color swatch dots — colors any [data-sv-swatch-value] dot
  // sitewide (product cards, tabs, etc.) using the same metal-tone map
  // used on the product page. Re-runs for dynamically inserted cards.
  var svMetalMap = [
    [/yellow gold|18k gold|^gold$/i, 'linear-gradient(135deg,#f7dc8a,#c9a227 60%,#8b6b1f)'],
    [/white gold/i, 'linear-gradient(135deg,#f4f4f2,#cfcfcb 60%,#9a9a96)'],
    [/rose gold/i, 'linear-gradient(135deg,#f4c9b8,#d99a7c 60%,#a76a52)'],
    [/platinum/i, 'linear-gradient(135deg,#eef0f1,#c7cbcd 60%,#9a9fa2)'],
    [/rhodium/i, 'linear-gradient(135deg,#ffffff,#d8dadb 60%,#a9acae)'],
    [/silver/i, 'linear-gradient(135deg,#f5f5f5,#c0c0c0 60%,#8e8e8e)']
  ];
  function colorSwatches() {
    document.querySelectorAll('[data-sv-swatch-value]:not([data-sv-swatch-done])').forEach(function (dot) {
      dot.setAttribute('data-sv-swatch-done', 'true');
      var val = dot.getAttribute('data-sv-swatch-value');
      var match = svMetalMap.find(function (m) { return m[0].test(val); });
      dot.style.background = match ? match[1] : 'rgba(28,23,18,.15)';
    });
  }
  colorSwatches();
  new MutationObserver(colorSwatches).observe(document.body, { childList: true, subtree: true });

  // ── Scroll progress bar — runs everywhere, no pointer required ──
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var bar = document.createElement('div');
    bar.id = 'sv-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function updateProgress() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - doc.clientHeight;
      var pct = scrollable > 0 ? (doc.scrollTop / scrollable) * 100 : 0;
      bar.style.width = pct + '%';
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(updateProgress);
          ticking = true;
        }
      },
      { passive: true }
    );
    updateProgress();
  }

  // ── Tilt-on-hover for product media & cards — perspective transform
  // that follows the cursor. Bounded to a few degrees to stay elegant.
  if (
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
    !window.matchMedia('(hover: none) and (pointer: coarse)').matches
  ) {
    function addTilt(el, maxDeg, lift) {
      if (el.dataset.svTiltBound) return;
      el.dataset.svTiltBound = 'true';
      el.style.transition = 'transform 0.2s ease-out';
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform =
          'perspective(1000px) rotateX(' + (-py * maxDeg) + 'deg) rotateY(' + (px * maxDeg) + 'deg)' +
          (lift ? ' translateY(-' + lift + 'px) scale(1.015)' : ' scale(1.015)');
      });
      el.addEventListener('mouseleave', function () {
        el.style.transition = 'transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94)';
        el.style.transform = '';
        setTimeout(function () {
          el.style.transition = 'transform 0.2s ease-out';
        }, 500);
      });
    }
    function bindTiltTargets() {
      document.querySelectorAll('.card-wrapper').forEach(function (el) {
        addTilt(el, 5, 4);
      });
      document.querySelectorAll('.product__media-wrapper .product__media, .sv-pi, .sv-col-img').forEach(function (el) {
        addTilt(el, 8, 0);
      });
    }
    bindTiltTargets();
    new MutationObserver(bindTiltTargets).observe(document.body, { childList: true, subtree: true });
  }

  // Magnetic pull on primary buttons — subtle offset toward the cursor.
  if (
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
    !window.matchMedia('(hover: none) and (pointer: coarse)').matches
  ) {
    document.querySelectorAll('.button, .product-form__submit').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var relX = e.clientX - r.left - r.width / 2;
        var relY = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + relX * 0.12 + 'px,' + relY * 0.28 + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }
})();
